(()=>{
  const norm=s=>(s||'').trim().toLowerCase();
  const sectionWrappers=()=>[...document.querySelectorAll('[id^="shopify-section-"]')];
  function editorType(el){try{const v=el.getAttribute('data-shopify-editor-section');return v?JSON.parse(v).type:null}catch(e){return null}}
  function targetFor(name){
    const map=window.KARHDIR_PRODUCT_NAV_SECTION_TYPES||{};
    const wanted=Object.keys(map).find(k=>norm(k)===norm(name));
    const type=wanted?map[wanted]:null;
    if(!type)return null;
    const wrappers=sectionWrappers();
    return wrappers.find(el=>editorType(el)===type)||wrappers.find(el=>{
      const id=el.id.toLowerCase();
      return id.includes('__'+type.replace(/-/g,'_'))||id.includes('__'+type.replace(/_/g,'-'));
    })||null;
  }

  let activeRoot=null;
  let ticking=false;
  let lastScrollY=window.scrollY||document.documentElement.scrollTop;
  let mobileNavVisible=false;
  const mobileQuery=window.matchMedia('(max-width: 749px)');

  function setHeaderMode(on){
    document.documentElement.classList.toggle('product-navigation-header-mode',on);
    const header=document.querySelector('.section-header');
    if(on){
      header?.classList.add('shopify-section-header-hidden');
    }else{
      header?.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate','scrolled-past-header','scrolling-down','scrolling-up');
    }
  }

  function setMobileVisibility(visible){
    mobileNavVisible=visible;
    document.documentElement.classList.toggle('product-navigation-mobile-visible',visible);
  }

  function update(){
    ticking=false;
    if(!activeRoot)return;
    const y=window.scrollY||document.documentElement.scrollTop;
    const atTop=y<=2;

    if(atTop){
      setHeaderMode(false);
      setMobileVisibility(false);
      lastScrollY=y;
      return;
    }

    setHeaderMode(true);

    if(mobileQuery.matches){
      const delta=y-lastScrollY;
      if(delta>=8){
        setMobileVisibility(false);
        lastScrollY=y;
      }else if(delta<=-8){
        setMobileVisibility(true);
        lastScrollY=y;
      }
    }else{
      setMobileVisibility(false);
    }

    activeRoot._updateProductNavigationActive?.();
    if(!mobileQuery.matches)lastScrollY=y;
  }

  function requestUpdate(){
    if(ticking)return;
    ticking=true;
    requestAnimationFrame(update);
  }

  function init(root){
    if(root.dataset.productNavigationInitialized==='true')return;
    root.dataset.productNavigationInitialized='true';
    const links=[...root.querySelectorAll('[data-product-nav-target]')];
    const targets=links.map(link=>targetFor(link.dataset.productNavTarget));
    let activeIndex=-1;

    function setActive(index,bringIntoView=false){
      if(index<0||index>=links.length||activeIndex===index)return;
      activeIndex=index;
      links.forEach((link,i)=>link.classList.toggle('is-active',i===index));
      if(bringIntoView&&mobileQuery.matches){
        links[index].scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
      }
    }

    function updateActiveFromScroll(){
      const headerLine=parseFloat(getComputedStyle(root).height)||0;
      const activationLine=headerLine+8;
      let nextIndex=0;
      targets.forEach((target,index)=>{
        if(target&&target.getBoundingClientRect().top<=activationLine)nextIndex=index;
      });
      setActive(nextIndex,true);
    }

    setActive(0);
    root.addEventListener('click',e=>{
      const b=e.target.closest('[data-product-nav-target]');
      if(!b)return;
      const index=links.indexOf(b);
      setActive(index,true);
      const t=targets[index]||targetFor(b.dataset.productNavTarget);
      if(t)t.scrollIntoView({behavior:'smooth',block:'start'});
      else console.warn('Product navigation target not found:',b.dataset.productNavTarget);
    });
    root._updateProductNavigationActive=updateActiveFromScroll;
    if(!activeRoot)activeRoot=root;
  }

  document.querySelectorAll('[data-product-navigation]').forEach(init);
  update();
  window.addEventListener('scroll',requestUpdate,{passive:true});
  mobileQuery.addEventListener?.('change',requestUpdate);
  document.addEventListener('shopify:section:load',e=>{
    const r=e.target.querySelector('[data-product-navigation]');
    if(r){activeRoot=r;init(r);requestUpdate()}
  });
})();
